// @flow
import React, { forwardRef } from 'react'
import { Image as KonvaImage } from 'react-konva'
import useImage from 'use-image'

type Props = {
  url: string
}

export const Image = forwardRef((props: Props, ref: React$Ref) => {
  // console.log('image', props)
  const { url, ...rest} = props
  const [ image ] = useImage(url)
  return <KonvaImage ref={ref} image={image} {...rest} />
})

export default Image
